import AiSecurityExperience from '@comp/ai/ai-security-experience'

export default function AiAgentsPage({ locale }: { locale: string }) {
  return <AiSecurityExperience page="agents" locale={locale} />
}

export async function getStaticProps({ locale }: { locale: string }) {
  return { props: { locale: locale ?? 'en' } }
}
